import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getStudioProjectLists } from "./actions";

export const studioProjectsEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity.id,
});

const initialState = studioProjectsEntityAdapter.getInitialState({
  count: 0,
  modals: {},
  groupByDate: {}, // projects created via Create New
});

export const studioProjectsSlice = createSlice({
  name: "studioProjects",
  initialState: initialState,
  reducers: {
    showStudioProjectsAllFiltersModal: (state, action) => {
      state.modals.studioProjectsAllFiltersModal = action.payload;
    },
    setStudioProjectsGroupByDate: (state, action) => {
      state.groupByDate = action.payload;
    },
    showStudioProjectsDeleteModal: (state, action) => {
      state.modals.studioProjectsDeleteModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getStudioProjectLists.fulfilled, (state, action) => {
      if (action.payload.success) {
        if (action.payload?.groupByDatepProjects) {
          /**
           * If its a new req with updated filters, them don't append in prev state
           */
          const isNewReq = action?.meta?.arg?.payload?.params?.pageNo === 1;
          const appendInExisting = action?.meta?.arg?.payload?.appendInExisting;
          const clearExistingStudioProjectClips = action?.meta?.arg?.payload?.clearExistingStudioProjectClips;

          if (isNewReq && !appendInExisting) {
            studioProjectsEntityAdapter.setAll(state, action.payload.entities?.studioProjectClips || {});
            state.groupByDate = action.payload.entities?.studioProjectsGroupByDate || {};
          } else {
            // for infinite scroll pagination
            studioProjectsEntityAdapter.setMany(state, action.payload.entities?.studioProjectClips || {});
            state.groupByDate = {
              ...(clearExistingStudioProjectClips ? {} : state.groupByDate),
              ...(action.payload.entities?.studioProjectsGroupByDate || {}),
            };
          }

          state.count = action.payload.totalLength;
        } else {
          state.ids = [];
          state.count = 0;
          state.entities = {};
          state.groupByDate = {};
        }
      }
    });
  },
});

export const { showStudioProjectsAllFiltersModal, setStudioProjectsGroupByDate, showStudioProjectsDeleteModal } =
  studioProjectsSlice.actions;

export default studioProjectsSlice.reducer;
